import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  RadioSelector,
  ErrorMsg,
} from "@onegovbugs/onegov-react-components";
import styles from "./Qualification.module.scss";
import {
  storeQualificationDetail,
  saveApplication,
} from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import QualificationList from "../../../components/floraFauna/qualification/QualificationList";
import QualificationForm from "./QualificationForm";
import { hasAnyValue, isSelected, validate } from "../../../utils/Validation";

const QualificationDetail = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();
  const [showErrors, setShowErrors] = useState(false);
  const qualificationDetail = useSelector((state) => state.qualificationDetail);
  const [qualificationList, setQualificationList] = useState(
    qualificationDetail && qualificationDetail.qualificationList
      ? qualificationDetail.qualificationList.map((on) => ({ ...on }))
      : []
  );
  const [hasQualification, setQualifications] = useState(
    qualificationDetail && qualificationDetail.hasQualification
      ? qualificationDetail.hasQualification
      : null
  );
  const radioOptionsQualifications = [
    {
      value: "yes",
      label: "Yes",
    },
    {
      value: "no",
      label: "No",
    },
  ];

  // validation
  const [errors, setErrors] = useState({
    hasQualification: false,
    qualificationList: false,
  });

  const validators = [
    {
      fieldName: "hasQualification",
      fieldValue: hasQualification,
      isValid: (v) => isSelected(v),
    },
    {
      fieldName: "qualificationList",
      fieldValue: qualificationList,
      isValid: (v) => hasQualification == "no" || hasAnyValue(v),
    },
  ];

  useEffect(() => {
    validate(validators, setErrors);
  }, [hasQualification, qualificationList]);

  const deleteActionHandler = (i) => {
    let values = [...qualificationList];
    values.splice(i, 1);
    setQualificationList([...values]);
    const qualificationRecord = {
      qualificationList: values
    };
    dispatch(storeQualificationDetail(qualificationRecord));
  };

  const storeData = (finished) => {
    const qualificationRecord = {
      hasQualification,
      qualificationList: hasQualification === "no" ? [] : qualificationList,
      finished,
      step : 2
    };

    dispatch(storeQualificationDetail(qualificationRecord));
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          Please include details of recent/relevant qualification. Additional
          information may be submitted as an attachment.
        </div>
      </div>
      <div className={`row ${styles.topMargin24}`}>
        <div className={"col-12"}>
          <label>Do you have any qualifications?</label>
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12"}>
          <div className={styles.topMargin24}>
            <RadioSelector
              options={radioOptionsQualifications}
              onSelectionChange={(selectedValue) => {
                setShowErrors(false);
                setQualifications(selectedValue);
              }}
              initialValue={hasQualification}
            />
            {errors.hasQualification && showErrors ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Please make a selection."}
              />
            ) : null}
          </div>
        </div>
      </div>
      {hasQualification == "yes" && (
        <>
          <div className={`row ${styles.topMargin24}`}>
            <div className={"col-12"}>
              <QualificationList
                props={props}
                qualificationList={qualificationList}
                deleteActionHandler={deleteActionHandler}
              />
            </div>
          </div>

          <div className={`row ${styles.buttonCont}`}>
            <div className={`col-12`}>
              <Button
                secondary
                onClick={() => {
                  props.history.push(`./qualification/detail`);
                }}
              >
                Add qualification
              </Button>
              {!errors.hasQualification &&
              errors.qualificationList &&
              showErrors ? (
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please add qualification."}
                />
              ) : null}
            </div>
          </div>
        </>
      )}

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData(true);
                dispatch(
                  saveApplication("step2", () => {
                    props.history.push(`../../flora-fauna/dashboard`);
                  })
                );
                setShowErrors(false);
              } else {
                setShowErrors(true);
              }
            }}
          >
            Continue
          </Button>

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication("step2", () => {
                  props.history.push(`../../flora-fauna/dashboard`);
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <QualificationDetail {...props} />);
